import React from 'react';
function Watermark() {
    return (React.createElement("div", { className: 'watermark-wrap' },
        React.createElement("div", { className: "watermark" },
            React.createElement("p", null, "Demo mode"),
            React.createElement("p", null, "not for clinical use"))));
}
export default Watermark;
